<script lang="ts">
    import { getContext, onMount } from "svelte";
    import { api, loader, swClient, toast, user } from "../stores";
    import {
        CampaignTypes,
        Document,
        Geoarea,
        GetCampaignTypeByName,
        MilestoneTypeValue,
        Operation,
        Types,
        UpdateCampaignIn,
        UpdateDocumentIn,
        UpdateMilestoneIn,
    } from "../model";
    import moment from "moment";
    import { useLocation } from "svelte-navigator";
    import ConfirmPopup from "./ConfirmPopup.svelte";

    import Modal, { bind } from "svelte-simple-modal";
    import { writable } from "svelte/store";

    const modal2 = writable(null);
    const { open } = getContext("simple-modal");
    const { close } = getContext("simple-modal");

    type InputName =
        | "name"
        | "type"
        | "displayDate"
        | "startDate"
        | "endDate"
        | "is_paf"
        | "show_paf"
        | "centrale";

    export let operation: Operation = null;
    let operationBackup: Operation;
    let formMode: "write" | "read" | "end-success" | "end-error" = "read";
    let inputNameShow: InputName | null = null;
    let documents: Document[] = [];
    let nbProducts = 0;
    let participatingShops = [];
    let shopListeHidden = true;
    let documentListeHidden = true;
    let location = useLocation();
    $: () => {
        console.log($location);
    };
    let input;
    let geoAreas: Geoarea[] = [];

    onMount(async () => {
        const documentProcessId = $loader.show("Chargement des versions");
        $swClient
            .getDocumentsByCampaign(operation.uid)
            .then((res) => {
                documents = res;
                $loader.hide(documentProcessId);
            })
            .catch((err) => {
                console.error(err);
                $loader.hide(documentProcessId);
            });
        const processId = $loader.show("Chargement des centrales");
        $swClient
            .getGeoAreas()
            .then((res) => {
                geoAreas = res;
                $loader.hide(processId);
            })
            .catch((e) => {
                console.error(e);
                $loader.hide(processId);
            });
    });

    /**
     * active the 'write' mode
     */
    function onEdite() {
        formMode = "write";
    }

    /**
     * validate the form and request to SW
     */
    function onValid() {
        console.log("onValid");
    }

    /**
     * cancel the write mode and come back to read mode
     */
    function onCancel() {
        formMode = "read";
        inputNameShow = null;
    }

    /**
     * close the modal
     */
    function onClose() {
        close();
    }

    function onToggleInput(inputName: InputName) {
        if (inputNameShow === null) {
            inputNameShow = inputName;
            formMode = "write";
        } else {
            inputNameShow = null;
            formMode = "read";
        }
    }

    function updateCampaign() {
        //set updatedate
        const currentTime = new Date().toISOString();
        // const lastUpdateIndex = operation.campaign.attrs.findIndex(attr => {
        //     return attr.key === 'updated_date';
        // });
        // if (lastUpdateIndex !== -1 ) {
        //     operation.campaign.attrs[lastUpdateIndex].value = currentTime;
        // } else {
        //     operation.campaign.attrs.push({key: "updated_date", value: currentTime});
        // }
        let newCampaign: UpdateCampaignIn = {
            name: operation.name,
            type_uid: GetCampaignTypeByName(operation.type).uid,
            attrs: operation.campaign.attrs,
            brand_uid: operation.campaign.brand_uids[0],
            geo_area_uid: operation.geo_area.uid,
            description: operation.campaign.description,
            cover: operation.campaign.cover,
        };
        const processId = $loader.show("Sauvegarde de l'opération en cours");
        $swClient
            .putCampaign(operation.uid, newCampaign)
            .then((res) => {
                $loader.hide(processId);
                $toast.success("Modifications réussi");
            })
            .catch((err) => {
                console.error(err);
                $loader.hide(processId);
                $toast.error();
            });
    }

    function updateMilstone(
        milestoneName: MilestoneTypeValue,
        dateValue: string,
        notif = true
    ) {
        const ml = operation.campaign.milestones.find(
            (e) => e.name === milestoneName
        );
        const newDate: UpdateMilestoneIn = {
            name: ml.name,
            date: dateValue,
            kind: ml.kind,
            brand_uids: ml.brand_uids,
        };
        $swClient
            .updateMilestoneCampaign(operation.uid, ml.uid, newDate)
            .then((res) => {
                if (notif) {
                    $toast.success("La date à bien été mise à jour");
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    function updateOperationName() {
        let newValue = input.value;
        if (operation.name !== newValue) {
            operation.name = newValue;
            updateCampaign();
        }
        onToggleInput("name");
    }

    function updateOperationType() {
        let newValue = input.value;
        if (operation.type !== newValue) {
            operation.type = newValue;
            updateCampaign();
        }
        onToggleInput("type");
    }

    function updateOperationDisplayDate() {
        let newValue = input.value;
        if (moment(operation.displayDate).format("YYYY-MM-DD") !== newValue) {
            operation.displayDate = new Date(newValue).toISOString();
            updateMilstone(
                Types.campaign.milestones.display_date,
                operation.displayDate
            );
        }
        onToggleInput("displayDate");
    }

    function updateOperationStartDate() {
        let newValue = input.value;
        if (moment(operation.startDate).format("YYYY-MM-DD") !== newValue) {
            operation.startDate = new Date(newValue).toISOString();
            updateMilstone(
                Types.campaign.milestones.start_date,
                operation.startDate
            );
        }
        onToggleInput("startDate");
    }

    function updateOperationEndDate() {
        let newValue = input.value;
        if (moment(operation.endDate).format("YYYY-MM-DD") !== newValue) {
            if (
                new Date(operation.startDate).getTime() >=
                new Date(new Date(new Date(newValue).toISOString())).getTime()
            ) {
                $toast.error(
                    "La date de fin doit être supérieur à la date de début."
                );
            } else {
                operation.endDate = new Date(newValue).toISOString();
                // updateMilstone(MtName.end, operation.endDate)
                updateMilstone(
                    Types.campaign.milestones.end_date,
                    operation.endDate
                );
            }
        }
        onToggleInput("endDate");
    }

    function updateOperationIsPaf() {
        let newValue = input.value === true || input.value === "true";
        if (operation.is_paf !== newValue) {
            if (operation.show_paf) {
                operation.is_paf = newValue;
                let found = false;
                operation.campaign.attrs.forEach((attr, i) => {
                    if (attr.key == Types.campaign.attrs.is_paf) {
                        found = true;
                        operation.campaign.attrs[i].value =
                            operation.is_paf.toString();
                    }

                    if (operation.campaign.attrs.length - 1 === i) {
                        if (!found) {
                            operation.campaign.attrs.push({
                                key: Types.campaign.attrs.is_paf,
                                value: operation.is_paf.toString(),
                            });
                        }
                        updateCampaign();
                    }
                });
            } else {
                $toast.error("Le feuilletable doit être activé.");
            }
        }
        onToggleInput("is_paf");
    }

    function updateOperationshowPaf() {
        let newValue = input.value === true || input.value === "true";
        if (operation.show_paf !== newValue) {
            operation.show_paf = newValue;
            let found = false;
            operation.campaign.attrs.forEach((attr, i) => {
                if (attr.key == Types.campaign.attrs.show_paf) {
                    found = true;
                    operation.campaign.attrs[i].value =
                        operation.show_paf.toString();
                }

                if (operation.campaign.attrs.length - 1 === i) {
                    if (!found) {
                        operation.campaign.attrs.push({
                            key: Types.campaign.attrs.show_paf,
                            value: operation.show_paf.toString(),
                        });
                    }
                    updateCampaign();
                }
            });
        }
        onToggleInput("show_paf");
    }

    function updateOperationCentrale() {
        let newValue = input.value;
        if (newValue !== "" && operation.geo_area.name !== newValue) {
            let index = geoAreas.findIndex((e) => e.name === newValue);
            if (index >= 0) {
                operation.geo_area = geoAreas[index];
                updateCampaign();
                // update documents
                documents.forEach((document) => {
                    let eIn: UpdateDocumentIn = {
                        attrs: document.attrs,
                        brand_uid: document.brand.uid,
                        cover: document.cover,
                        external_url: document.external_url,
                        geo_area_uid: operation.geo_area.uid,
                        index_offset: document.index_offset,
                        name: document.name,
                        page_numbering: document.page_numbering,
                        related_document_uid: document.related_document_uid,
                        rough_print_quantity: document.rough_print_quantity,
                        type_uid: document.type.uid,
                    };
                    const processId = $loader.show(
                        "Mise à jour de la vitesse '" +
                            document.name +
                            "' en cours"
                    );
                    $swClient
                        .updateDocument(document.uid, eIn)
                        .then((res) => {
                            $loader.hide(processId);
                        })
                        .catch((e) => {
                            $toast.error(e);
                            console.error(e);
                            $loader.hide(processId);
                        });
                });
            } else {
                console.error("Le géo area nà pas été trouvé.");
            }
        }
        onToggleInput("centrale");
    }

    function deletepOperation() {
        const onOkay = async () => {
            const processId = $loader.show(
                "Suppression de l'opération en cours"
            );
            $api.deleteCampaign(operation.uid, $swClient.token)
                .then((res) => {
                    $loader.hide(processId);
                    $toast.success("L'opération à bien été supprimée.");
                    onClose();
                })
                .catch((e) => {
                    $loader.hide(processId);
                    console.error(e);
                    $toast.error(
                        "Une erreur s'est produite. Consultez la console pour plus d'information."
                    );
                    onClose();
                });
        };

        modal2.set(
            bind(
                ConfirmPopup,
                {
                    onOkay,
                    title: "Confirmation",
                    content:
                        "Êtes-vous certain de vouloir supprimer cette opération: " +
                        operation.code +
                        ": " +
                        operation.name +
                        " ?",
                },
                {
                    closeOnOuterClick: false,
                    closeOnEsc: false,
                    closeButton: false,
                }
            )
        );
    }

    function onRemoveDocument(document: Document) {
        const onOkay = async () => {
            const processId = $loader.show(
                "Suppression de la version " + document.name + " en cours"
            );
            $api.deleteDocument(document.uid, $swClient.token)
                .then((res) => {
                    $loader.hide(processId);
                    $toast.success(
                        "La version " + document.name + " à bien été supprimée."
                    );
                    onClose();
                })
                .catch((e) => {
                    $loader.hide(processId);
                    console.error(e);
                    $toast.error(
                        "Une erreur s'est produite. Consultez la console pour plus d'information."
                    );
                    onClose();
                });
        };

        modal2.set(
            bind(
                ConfirmPopup,
                {
                    onOkay,
                    title: "Confirmation",
                    content:
                        "Êtes-vous certain de vouloir supprimer cette version: " +
                        document.name +
                        " ?",
                },
                {
                    closeOnOuterClick: false,
                    closeOnEsc: false,
                    closeButton: false,
                }
            )
        );
    }
</script>

<Modal show={$modal2}>
    {#if operation}
        <div id="modal">
            <div class="line">
                <div class="col-data">
                    <h1 class="txt-dark-black">{operation.code}</h1>
                </div>
            </div>

            <!-- ==== OPERATION NAME ==== -->
            <div class="line">
                <div class="col-btn">
                    {#if inputNameShow === "name"}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                updateOperationName();
                            }}
                            title="valider"
                        >
                            <i class="fas fa-check" />
                        </button>
                        <button
                            class="button btn-cancel mr-2"
                            on:click={() => {
                                onCancel();
                            }}
                            title="annuler"
                        >
                            <i class="fas fa-ban" />
                        </button>
                    {:else}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                onToggleInput("name");
                            }}
                            title="éditer"
                            disabled={inputNameShow && inputNameShow !== "name"}
                        >
                            <i class="fas fa-pen" />
                        </button>
                    {/if}
                </div>
                <div class="col-data">
                    {#if formMode === "write" && inputNameShow === "name"}
                        <input
                            type="text"
                            value={operation.name}
                            bind:this={input}
                        />
                    {:else}
                        <h3 class="txt-blue">{operation.name}</h3>
                    {/if}
                </div>
            </div>

            <!-- ==== OPERATION TYPE ==== -->
            <!-- <div class="line">
                {#if isUserElpev}
                    <div class="col-btn">
                        {#if inputNameShow === "type"}
                            <button class="button btn-elpev mr-2" on:click="{() => {updateOperationType()}}"
                                    title="valider">
                                <i class="fas fa-check"></i>
                            </button>
                            <button class="button btn-cancel mr-2" on:click="{() => {onCancel()}}" title="annuler">
                                <i class="fas fa-ban"></i>
                            </button>
                        {:else}
                            <button class="button btn-elpev mr-2" on:click="{() => {onToggleInput('type')}}"
                                    title="éditer"
                                    disabled="{inputNameShow && inputNameShow !== 'type'}">
                                <i class="fas fa-pen"></i>
                            </button>
                        {/if}
                    </div>
                {/if}
                <div class="col-data">
                    {#if formMode === "write" && inputNameShow === "type" && isUserElpev}
                        <select value={operation.type} bind:this={input}>
                            {#each CampaignTypes as campaignType}
                                <option value={campaignType.name} disabled="{operation.type === campaignType.name}">{campaignType.name.charAt(0).toUpperCase() + campaignType.name.slice(1)}
                                </option>
                            {/each}
                        </select>
                    {:else}
                        Opération de type {operation.type}.
                    {/if}
                </div>
            </div> -->

            <!-- ==== OPERATION DISPLAYDATE ==== -->
            <div class="line">
                <div class="col-btn">
                    {#if inputNameShow === "displayDate"}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                updateOperationDisplayDate();
                            }}
                            title="valider"
                        >
                            <i class="fas fa-check" />
                        </button>
                        <button
                            class="button btn-cancel mr-2"
                            on:click={() => {
                                onCancel();
                            }}
                            title="annuler"
                        >
                            <i class="fas fa-ban" />
                        </button>
                    {:else}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                onToggleInput("displayDate");
                            }}
                            title="éditer"
                            disabled={inputNameShow &&
                                inputNameShow !== "displayDate"}
                        >
                            <i class="fas fa-pen" />
                        </button>
                    {/if}
                </div>
                <div class="col-data">
                    {#if formMode === "write" && inputNameShow === "displayDate"}
                        <input
                            type="date"
                            value={moment(operation.displayDate).format(
                                "YYYY-MM-DD"
                            )}
                            bind:this={input}
                        />
                    {:else}
                        S'affiche à partir du <b
                            >{moment(operation.displayDate).format(
                                "DD/MM/YYYY"
                            )}</b
                        >.
                    {/if}
                </div>
            </div>

            <!-- ==== OPERATION STARTDATE ==== -->
            <div class="line">
                <div class="col-btn">
                    {#if inputNameShow === "startDate"}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                updateOperationStartDate();
                            }}
                            title="valider"
                        >
                            <i class="fas fa-check" />
                        </button>
                        <button
                            class="button btn-cancel mr-2"
                            on:click={() => {
                                onCancel();
                            }}
                            title="annuler"
                        >
                            <i class="fas fa-ban" />
                        </button>
                    {:else}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                onToggleInput("startDate");
                            }}
                            title="éditer"
                            disabled={inputNameShow &&
                                inputNameShow !== "startDate"}
                        >
                            <i class="fas fa-pen" />
                        </button>
                    {/if}
                </div>
                <div class="col-data">
                    {#if formMode === "write" && inputNameShow === "startDate"}
                        <input
                            type="date"
                            value={moment(operation.startDate).format(
                                "YYYY-MM-DD"
                            )}
                            bind:this={input}
                        />
                    {:else}
                        Commence le <b
                            >{moment(operation.startDate).format(
                                "DD/MM/YYYY"
                            )}</b
                        >.
                    {/if}
                </div>
            </div>

            <!-- ==== OPERATION ENDDATE ==== -->
            <div class="line">
                <div class="col-btn">
                    {#if inputNameShow === "endDate"}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                updateOperationEndDate();
                            }}
                            title="valider"
                        >
                            <i class="fas fa-check" />
                        </button>
                        <button
                            class="button btn-cancel mr-2"
                            on:click={() => {
                                onCancel();
                            }}
                            title="annuler"
                        >
                            <i class="fas fa-ban" />
                        </button>
                    {:else}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                onToggleInput("endDate");
                            }}
                            title="éditer"
                            disabled={inputNameShow &&
                                inputNameShow !== "endDate"}
                        >
                            <i class="fas fa-pen" />
                        </button>
                    {/if}
                </div>
                <div class="col-data">
                    {#if formMode === "write" && inputNameShow === "endDate"}
                        <input
                            type="date"
                            value={moment(operation.endDate).format(
                                "YYYY-MM-DD"
                            )}
                            bind:this={input}
                        />
                    {:else}
                        Se termine le <b
                            >{moment(operation.endDate).format("DD/MM/YYYY")}</b
                        >.
                    {/if}
                </div>
            </div>

            <!-- ==== OPERATION SHOWPAF ==== -->
            <div class="line">
                <div class="col-btn">
                    {#if inputNameShow === "show_paf"}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                updateOperationshowPaf();
                            }}
                            title="valider"
                        >
                            <i class="fas fa-check" />
                        </button>
                        <button
                            class="button btn-cancel mr-2"
                            on:click={() => {
                                onCancel();
                            }}
                            title="annuler"
                        >
                            <i class="fas fa-ban" />
                        </button>
                    {:else}
                        <button
                            class="button btn-elpev mr-2"
                            on:click={() => {
                                onToggleInput("show_paf");
                            }}
                            title="éditer"
                            disabled={inputNameShow &&
                                inputNameShow !== "show_paf"}
                        >
                            <i class="fas fa-pen" />
                        </button>
                    {/if}
                </div>
                <div class="col-data">
                    {#if formMode === "write" && inputNameShow === "show_paf"}
                        <select value={operation.show_paf} bind:this={input}>
                            <option
                                value={true}
                                disabled={operation.show_paf === true}
                                >Oui</option
                            >
                            <option
                                value={false}
                                disabled={operation.show_paf === false}
                                >Non</option
                            >
                        </select>
                    {:else}
                        Afficher le feuilletable: <b
                            >{operation.show_paf ? "Oui" : "Non"}</b
                        >.
                    {/if}
                </div>
            </div>

            <!-- ==== OPERATION ISPAF ==== -->
            {#if operation.show_paf}
                <div class="line">
                    <div class="col-btn">
                        {#if inputNameShow === "is_paf"}
                            <button
                                class="button btn-elpev mr-2"
                                on:click={() => {
                                    updateOperationIsPaf();
                                }}
                                title="valider"
                            >
                                <i class="fas fa-check" />
                            </button>
                            <button
                                class="button btn-cancel mr-2"
                                on:click={() => {
                                    onCancel();
                                }}
                                title="annuler"
                            >
                                <i class="fas fa-ban" />
                            </button>
                        {:else}
                            <button
                                class="button btn-elpev mr-2"
                                on:click={() => {
                                    onToggleInput("is_paf");
                                }}
                                title="éditer"
                                disabled={inputNameShow &&
                                    inputNameShow !== "is_paf"}
                            >
                                <i class="fas fa-pen" />
                            </button>
                        {/if}
                    </div>
                    <div class="col-data">
                        {#if formMode === "write" && inputNameShow === "is_paf"}
                            <select value={operation.is_paf} bind:this={input}>
                                <option
                                    value={true}
                                    disabled={operation.is_paf === true}
                                    >Oui</option
                                >
                                <option
                                    value={false}
                                    disabled={operation.is_paf === false}
                                    >Non</option
                                >
                            </select>
                        {:else}
                            Feuilletable uniquement: <b
                                >{operation.is_paf ? "Oui" : "Non"}</b
                            >.
                            {#if !operation.show_paf && operation.is_paf}
                                <br /><span class="txt-warn"
                                    >(Le feuilletable doit être activé pour permettre
                                    uniquement son affichage.)</span
                                >
                            {/if}
                        {/if}
                    </div>
                </div>
            {/if}

            <!-- ==== OPERATION VERISONS LIST ==== -->
            <ul>
                {#if documents.length > 0}
                    <li>
                        Liste des versions:
                        <!-- svelte-ignore a11y-missing-attribute -->
                        <a
                            on:click={() => {
                                documentListeHidden = !documentListeHidden;
                            }}
                        >
                            <span class={documentListeHidden ? "" : "hide"}
                                ><i class="fas fa-arrow-circle-down" /></span
                            >
                            <span class={!documentListeHidden ? "" : "hide"}
                                ><i class="fas fa-arrow-circle-up" /></span
                            >
                        </a>
                        <ul class={documentListeHidden ? "hide" : ""}>
                            {#each documents as document}
                                <li>
                                    <button
                                        class="button is-danger is-light is-small"
                                        style="border-radius: 10px;"
                                        on:click={() =>
                                            onRemoveDocument(document)}
                                    >
                                        <span class="fas fa-times" />
                                    </button>
                                    {document.name}
                                </li>
                            {/each}
                        </ul>
                    </li>
                {/if}
            </ul>

            <!-- BUTTONS -->
            <div id="footer">
                <button
                    class="button btn-elpev"
                    on:click={onClose}
                    disabled={inputNameShow}
                >
                    Fermer
                </button>
                <button class="button btn-red" on:click={deletepOperation}>
                    <i class="fas fa-trash-alt mr-2" /> Supprimer
                </button>
            </div>
        </div>
    {/if}
</Modal>

<style lang="scss">
    @import "../styles/variables";

    .hide {
        display: none;
    }

    .txt-warn {
        font-size: 0.9rem;
        color: red;
    }

    .btn-red {
        background-color: $red;
        color: white;
        border-radius: 10px;
    }

    #modal {
        margin-top: 10px;
    }

    .line {
        display: flex;
        align-items: baseline;
        margin: 5px 0;
        height: 40px;

        h1 {
            margin: 0;
        }

        input {
            height: 100%;
            width: 100%;
        }

        .col-btn {
            width: 100px;
            display: flex;
            justify-content: center;
        }
    }

    #footer {
        margin-top: 10px;
        width: 100%;
        text-align: center;

        button {
            margin: 0 5px;
            width: 150px;
        }
    }
</style>
